// ICON IMPORT
import { DashIcon } from "icons/sidebar/DashIcon";
import { WalletIcon } from "icons/sidebar/WalletIcon";
import { MoneyTimeIcon } from "icons/sidebar/MoneyTimeIcon";
import { CoinIcon } from "icons/sidebar/CoinIcon";
import { DocumentTextIcon } from "icons/sidebar/DocumentTextIcon";
import { SubscriptionsIcon } from "icons/sidebar/SubscriptionsIcon";

interface MenuItems {
  id: string;
  title: string;
  url: string;
  icon: any;
  className: string;
}

export const menuItems: MenuItems[] = [
  {
    id: "dashboard",
    title: "Dashboard",
    url: "/dashboard",
    icon: DashIcon,
    className: "w-fit",
  },
  {
    id: "payments",
    title: "Payments",
    url: "/payments",
    icon: WalletIcon,
    className: "w-fit",
  },
  {
    id: "subscriptionsPlans",
    title: "Subscriptions & Plans",
    url: "/subscriptions-plans",
    icon: SubscriptionsIcon,
    className: "w-[145px]",
  },
  {
    id: "actionCenter",
    title: "Action Center",
    url: "/action-center",
    icon: MoneyTimeIcon,
    className: "w-max",
  },
  {
    id: "paymentMethods",
    title: "Payment Methods",
    url: "/payment-methods",
    icon: CoinIcon,
    className: "w-[120px]",
  },
  {
    id: "documents",
    title: "Documents",
    url: "/documents",
    icon: DocumentTextIcon,
    className: "w-fit",
  },
];
